const weekdays = ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'];

export const parseCampaignWeekdays = (value: string): number[] => {
    if (!value.trim()) return [];
    const days = value.split(',').map(part => {
        const token = part.trim().toLowerCase();
        const day = /^[0-6]$/.test(token) ? Number(token) : weekdays.indexOf(token);
        if (day < 0) {
            throw new Error('Vientipäivät: käytä lyhenteitä ma, ti, ke, to, pe, la, su pilkuilla eroteltuina.');
        }
        return day;
    });
    return Array.from(new Set(days));
};

export const formatCampaignWeekdays = (value: string | number[] | null | undefined): string => {
    const text = Array.isArray(value) ? value.join(', ') : value || '';
    return text.replace(/\b[0-6]\b/g, day => weekdays[Number(day)]);
};
